import React from 'react';
import { Box } from '@mui/material';
import CIHAChartsContainer from '../Common/CIHAChartsContainer';
import ProceduresWrapper from './index';

const Procedures = () => {
    return (
        <Box>
            <Box className="content">
                <CIHAChartsContainer
                    title={'Procedimentos / Produção'}
                    className="services-container-dashboards"
                >
                    <ProceduresWrapper />
                </CIHAChartsContainer>
            </Box>
        </Box>
    );
};

export default Procedures;
